// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProductContext, withProductContext } from "@insite/client-framework/Components/ProductContext";
import ProductAddToListLink, {
    ProductAddToListLinkStyles,
} from "@insite/content-library/Components/ProductAddToListLink";
import ProductListProductImage, {
    ProductListProductImageStyles,
} from "@insite/content-library/Widgets/ProductList/ProductListProductImage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { mergeWithCss } from "@steiner/XDL/Utilities";
import React, { FC, useState } from "react";

export interface ProductCompareAndAddToListProps {
    showAddToList?: boolean;
    showCompare?: boolean;
    extendedStyles?: ProductCompareAndAddToListStyle;
}

type Props = ProductCompareAndAddToListProps & HasProductContext;

export interface ProductCompareAndAddToListStyle {
    wrapper?: InjectableCss;
    addToListLink?: ProductAddToListLinkStyles;
    productImageStyles?: ProductListProductImageStyles;
}

export const productCompareAndAddToListStyle: ProductCompareAndAddToListStyle = {};

const ProductCompareAndAddToList: FC<Props> = ({
    showAddToList = true,
    extendedStyles,
    showCompare = false,
    productContext,
}) => {
    const [styles] = useState(() => mergeWithCss(productCompareAndAddToListStyle, extendedStyles));
    return (
        <>
            <StyledWrapper {...styles.wrapper}>
                <ProductListProductImage
                    extendedStyles={styles.productImageStyles}
                    showImage={false}
                    showCompare={showCompare}
                />
                {showAddToList && <ProductAddToListLink extendedStyles={styles.addToListLink} />}
            </StyledWrapper>
        </>
    );
};

export default withProductContext(ProductCompareAndAddToList);
